// extracted by mini-css-extract-plugin
export default {"emojiIconContainer":"BiNraCLC89V9W8eRJQoY","small":"szGTvhSn_TM4a4jCr6Le","large":"uTO0FhKmsHhSmzapTJNK"};